import React, { useState, useCallback } from "react";
import { DatePreset } from "../../../components/DatePreset";

interface DatePresetFilterProps {
  setDateFilter: (range: [number, number] | undefined) => void;
  reportDate: string;
}

export default function DatePresetFilter({
  setDateFilter,
  reportDate,
}: DatePresetFilterProps) {
  const [selected, setSelected] = useState<string | undefined>();
  const options = ["30", "45", "60", "90"];

  const onDateSelect = useCallback(
    (selectedOption?: string) => {
      setSelected(selectedOption);

      if (!selectedOption) {
        setDateFilter(undefined);
        return;
      }
      const dateOffset = parseInt(selectedOption);

      if (Number.isNaN(dateOffset)) {
        setDateFilter(undefined);
        return;
      }

      const formattedReportDate = new Date(reportDate);
      const startDate = new Date();
      const endDate = new Date();

      setDateFilter([
        startDate.setTime(
          formattedReportDate.getTime() - dateOffset * 24 * 60 * 60 * 1000
        ),
        endDate.setTime(
          formattedReportDate.getTime() + 1 * 24 * 60 * 60 * 1000
        ),
      ]);
    },
    [reportDate, setDateFilter]
  );

  return (
    <DatePreset onSelect={onDateSelect} options={options} selected={selected} />
  );
}
